import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { NeutralTag } from '@grnhse/seedling/lib/birch/components/tags';

type Tag = { label: string; value: string | number };

interface TagsCellProps {
  tags?: Tag[];
}

const TagsCell = ({ tags }: TagsCellProps) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div
      className="pii-blur"
      style={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}
    >
      <Stack
        direction="row"
        spacing={1}
        flexWrap="wrap"
        alignContent="flex-start"
        sx={{
          padding: 1,
          paddingLeft: 0,
        }}
      >
        {tags.map((tag) => (
          <NeutralTag key={tag.value} text={tag.label} />
        ))}
      </Stack>
    </div>
  );
};

export default TagsCell;
